function googleTranslateElementInit() {
  if (!iCreateObject.isSiteInICreateMode) {
    new google.translate.TranslateElement(
      {
        pageLanguage: iCreateObject.lang,
        layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
        gaTrack: true,
        gaId: iCreateObject.gaTrackingCode,
      },
      "google_translate_element"
    );
    var removePopup = document.getElementById("goog-gt-tt");
    removePopup.parentNode.removeChild(removePopup);
  }
}

$(document).ready(function () {
  if ($("#google_translate_element").length) {
    var temp = "";
    var observer = new MutationObserver(function (mutations) {
      let ggTranslateBtn =
          iCreateObject.languageResources &&
          iCreateObject.languageResources[
            "AriaLabel_Common_GoogleTranslateButton"
          ]
            ? iCreateObject.languageResources[
                "AriaLabel_Common_GoogleTranslateButton"
              ]
            : "Google Translate Button",
        ggTranslateTxt =
          iCreateObject.languageResources &&
          iCreateObject.languageResources["Common_Includes_Translate_Text"]
            ? iCreateObject.languageResources["Common_Includes_Translate_Text"]
            : "Translate",
        ggTranslateWidget =
          iCreateObject.languageResources &&
          iCreateObject.languageResources["AriaLabel_Common_GoogleTranslate"]
            ? iCreateObject.languageResources[
                "AriaLabel_Common_GoogleTranslate"
              ]
            : "Google Translate Widget";

      mutations.forEach(function (mutation) {
        var nodes = Array.prototype.slice.call(mutation.addedNodes);

        nodes.forEach(function (node) {
          if ($(node).find(".goog-te-menu-value").length) {
            var $button = $(node).find(".goog-te-menu-value");
            $button.attr("aria-label", ggTranslateBtn);
          }
          if ($(node).find(".goog-te-menu-value > span:first-child").length) {
            if (
              $(node).get(0).nodeType === Node.ELEMENT_NODE &&
              $(node).is("span")
            ) {
              $(node).find("span:first").text(ggTranslateTxt);
              temp = $(node).html();
              $(node).html(temp.replace("Select Language", ggTranslateTxt));
              $("#goog-gt-tt").each(function (ev) {
                $(this).attr("role", "region");
                $(this).attr("aria-label", ggTranslateWidget);
              });
            }
          } else if (
            $(node).get(0).nodeType === Node.TEXT_NODE &&
            $(node).parents(".goog-te-menu-value").length
          ) {
            node.nodeValue = ggTranslateTxt;
            $("#goog-gt-tt").each(function (ev) {
              $(this).attr("role", "region");
              $(this).attr("aria-label", ggTranslateWidget);
            });
          }
        });
      });
    });
    observer.observe(document.querySelector("#google_translate_element"), {
      childList: true,
      subtree: true,
      attributes: false,
      characterData: false,
    });
  }
});
